import { option } from 'fp-ts';
import { useEffect } from 'react';
import { AnyAction } from 'redux';
import { useDispatch } from 'react-redux';
import { isDefined } from 'utils/tsHelpers';
import { isEmpty } from '@iterable/utils';
import { toggleEditMode } from 'modules/queryBuilder/legacyQueryBuilder/actions';
import { useCatalogContext } from 'modules/catalog/catalogSelector';
import { useCatalogQueryContext } from '../../../contexts/catalogQuery';

export const useResetCatalogDrawer = () => {
  const dispatch = useDispatch();

  const { change, changeFieldDetails } = useCatalogContext();
  const { catalogQueryDetails } = useCatalogQueryContext();
  const toggleBuilderEditMode = () => dispatch(toggleEditMode() as AnyAction);

  useEffect(() => {
    const catalogQuery = catalogQueryDetails?.catalogQuery;
    const isEmptyCatalogQuery = isDefined(catalogQuery) && isEmpty(catalogQuery);

    if (isEmptyCatalogQuery) {
      change(option.none); // change catalog to none
      changeFieldDetails(option.none); // change catalog field to none
      toggleBuilderEditMode(); // change builder mode to edit
    }
  }, [catalogQueryDetails?.catalogQuery]);
};
